import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (account) =>
    present(
      repository
        .getUserPreferences(account)
        .then((preferences) => ({ account, preferences }))
        .catch(() => Promise.reject(account)),
    );
}

export type { Interactor };

export { createInteractor };
